function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26418_8014)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M138 276C214.215 276 276 214.215 276 138C276 61.7847 214.215 0 138 0C61.7847 0 0 61.7847 0 138C0 214.215 61.7847 276 138 276Z",
  fill: "#1C9CE4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.615 44.7856C128.078 44.7856 133.317 39.5463 133.317 33.0832C133.317 26.6201 128.078 21.3808 121.615 21.3808C115.152 21.3808 109.912 26.6201 109.912 33.0832C109.912 39.5463 115.152 44.7856 121.615 44.7856Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.371 31.0684C118.154 31.0684 119.6 29.6226 119.6 27.8392C119.6 26.0557 118.154 24.61 116.371 24.61C114.587 24.61 113.142 26.0557 113.142 27.8392C113.142 29.6226 114.587 31.0684 116.371 31.0684Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.128 44.7856C160.591 44.7856 165.83 39.5463 165.83 33.0832C165.83 26.6201 160.591 21.3808 154.128 21.3808C147.665 21.3808 142.425 26.6201 142.425 33.0832C142.425 39.5463 147.665 44.7856 154.128 44.7856Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.884 31.0684C150.667 31.0684 152.113 29.6226 152.113 27.8392C152.113 26.0557 150.667 24.61 148.884 24.61C147.1 24.61 145.654 26.0557 145.654 27.8392C145.654 29.6226 147.1 31.0684 148.884 31.0684Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138 55.8992H181.433C181.433 79.7272 161.828 99.3324 138 99.3324C114.172 99.3324 94.5668 79.7272 94.5668 55.8992H138Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26418_8014"
}, /*#__PURE__*/React.createElement("rect", {
  width: 276,
  height: 276,
  fill: "white"
})));

var SvgBubble = function SvgBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 118,
    viewBox: "0 0 276 118",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bubble.720397fe.svg";
export { ForwardRef as ReactComponent };